<ng-container *transloco="let t">
    <bazis-button
        size="mini"
        fill="clear"
        [disabled]="!(buttonStatus$ | async)?.prevEnabled"
        (click)="changeDate(-1)"
    >
        <bazis-icon
            slot="icon-only"
            [name]="icons.left"
        ></bazis-icon>
    </bazis-button>
    <div>
        <bazis-button
            size="mini"
            fill="clear"
            #generalBtn
            [active]="showCalendarFrom"
            (click)="openDateCalendarFrom($event)"
        >
            <bazis-icon
                slot="start"
                size="compact"
                [name]="icons.date"
            ></bazis-icon>
            @if (!showCalendarFrom) {
                @if (!value.value.from && !value.value.to) {
                    {{ t('title.hasNot') }}
                }
                @if (value.value.from === today && !value.value.to) {
                    {{ t('title.today') }}
                } @else {
                    {{ value.value.from }}
                    @if (value.value.to && value.value.to !== value.value.from) {
                        &nbsp;&mdash;&nbsp;{{ value.value.to }}
                    }
                }
                @if (value.value.from && amount) {
                    <bazis-badge
                        slot="end"
                        class="tms-badge_quantifier"
                        size="huge"
                    >
                        {{ amount }}
                    </bazis-badge>
                }
            } @else {
                {{ t('action.selectDate') }}
            }
        </bazis-button>
    </div>
    <bazis-button
        size="mini"
        fill="clear"
        [disabled]="!(buttonStatus$ | async)?.nextEnabled"
        (click)="changeDate(1)"
    >
        <bazis-icon
            slot="icon-only"
            [name]="icons.right"
        ></bazis-icon>
    </bazis-button>

    @if (showCalendarFrom) {
        <div
            class="tms-date-filter__calendar-wrap"
            clickOutside
            [excludeElement]="generalBtn.el"
            (clickOutside)="clickPopperFromOutside()"
            (click)="clickPopperFrom()"
        >
            <bazis-datepicker
                [value]="calendarValue"
                [minDate]="minDate"
                [maxDate]="maxDate"
                [marks$]="marks$"
                [canToggleDay]="false"
                [viewConfig]="datapickerViewConfig"
                [calendarsNumber]="calendarsNumber"
                (valueChange)="setValueFromCalendar($event)"
                (startCalendarChange)="startCalendarChange.emit($event)"
            ></bazis-datepicker>
        </div>
    }
</ng-container>
